import { useHistory, useRouteMatch } from "react-router";

import { UserInfoContext } from "helpers/globalContext/UserInfoContext";

import { type BTSelectItem } from "types/apiResponse/apiResponse";

import { routes } from "utilities/routes";

import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import { type TaxGroupServiceListItemExtraData } from "commonComponents/financial/TaxRateSelect/TaxRateSelect.api.types";

import { TaxSetupContainerRoute } from "entity/tax/TaxesSetupContainer/TaxSetupContainerRoute";
import { type ITaxGroupHandler, TaxGroupHandler } from "entity/tax/TaxGroup/TaxGroup.api.handler";
import { type TaxGroups } from "entity/tax/TaxGroupList/TaxGroupList.api.types";

export interface ITaxRateSelectManagementProps {
    builderId: number;
    jobId?: number;
    proposalId?: number;
    showImportOption?: boolean;
    taxGroupHandler?: ITaxGroupHandler;
    onTaxGroupUpdate?: (taxGroups: BTSelectItem<TaxGroupServiceListItemExtraData>[]) => void;
}

const defaultHandler = new TaxGroupHandler();
export const TaxRateSelectManagement: React.FunctionComponent<ITaxRateSelectManagementProps> = ({
    builderId,
    jobId,
    proposalId,
    showImportOption,
    taxGroupHandler = defaultHandler,
    onTaxGroupUpdate,
}: ITaxRateSelectManagementProps) => {
    const history = useHistory();
    const match = useRouteMatch();

    const reloadTaxDropDown = async (
        builderId: number,
        taxGroupHandler: ITaxGroupHandler,
        jobId?: number,
        proposalId?: number,
        showImportOption?: boolean,
    ) => {
        let apiResponse: TaxGroups;
        try {
            apiResponse = await taxGroupHandler.getTaxGroups(
                builderId,
                jobId,
                proposalId,
                showImportOption,
            );
            return apiResponse.taxGroups;
        } catch (e) {
            return [];
        }
    };
    const handleBeforeClose = async () => {
        history.replace(match.url);
        onTaxGroupUpdate?.(
            await reloadTaxDropDown(
                builderId,
                taxGroupHandler,
                jobId,
                proposalId,
                showImportOption,
            ),
        );
    };
    const handleAddTax = async () => {
        history.replace(match.url + routes.tax.settings);
    };
    return (
        <UserInfoContext.Consumer>
            {(context) => {
                const isAdmin = context?.isAdmin ?? false;
                if (!isAdmin) {
                    return null;
                }
                return (
                    <div>
                        <TaxSetupContainerRoute
                            modalConfig={{
                                parentRoute: match.url,
                                beforeClose: handleBeforeClose,
                            }}
                        />
                        <BTButtonDeprecated
                            className="ManageTaxLink"
                            data-testid="manage-tax-link-button"
                            type="link"
                            onClick={handleAddTax}
                            aria-label="Manage taxes"
                        >
                            Manage
                        </BTButtonDeprecated>
                    </div>
                );
            }}
        </UserInfoContext.Consumer>
    );
};
